import { useState, useRef } from "react";
import {
  HiSparkles,
  HiPhoto,
  HiCloudArrowUp,
  HiSwatch,
  HiArrowDownTray,
  HiCheckCircle,
  HiXMark,
  HiUser,
  HiPencil,
  HiCursorArrowRays,
  HiEye,
  HiSquares2X2,
  HiViewColumns
} from 'react-icons/hi2';
import img01 from './aseets/tools/design-01.png';
import img02 from './aseets/tools/design-02.png';
import img03 from './aseets/tools/design-03.png';
import img04 from './aseets/tools/design-04.png';
import img05 from './aseets/tools/design-05.png';
import img06 from './aseets/tools/design-06.png';
import img07 from './aseets/tools/design-07.png';
import img08 from './aseets/tools/design-08.png';
import img09 from './aseets/tools/design-09.png';
import img10 from './aseets/tools/design-10.png';
import img11 from './aseets/tools/design-11.png';
import img12 from './aseets/tools/design-12.png';
import img13 from './aseets/tools/design-13.png';
import img14 from './aseets/tools/design-14.png';
import img15 from './aseets/tools/design-15.png';
import img16 from './aseets/tools/design-16.png';
import 'react-toastify/dist/ReactToastify.css';
import 'bootstrap/dist/css/bootstrap.min.css';
const BrandStyles = () => (
  <style>{`
    .sbd-root {
      min-height: 100vh;
      width: 100%;
      background: #fff;
      position: relative;
      overflow-x: hidden;
    }
    .sbd-glow {
      position: fixed;
      border-radius: 50%;
      pointer-events: none;
      z-index: 0;
    }
    .sbd-glow-1 {
      top: 0; left: 0; width: 600px; height: 600px;
      background: #ff5266; opacity: 0.06; filter: blur(120px);
      transform: translate(-50%, -50%);
    }
    .sbd-glow-2 {
      bottom: 0; right: 0; width: 700px; height: 700px;
      background: #ff9a3e; opacity: 0.06; filter: blur(150px);
      transform: translate(33%, 33%);
    }
    .sbd-glow-3 {
      top: 50%; left: 50%; width: 400px; height: 400px;
      background: #ff5266; opacity: 0.03; filter: blur(100px);
      transform: translate(-50%, -50%);
    }

    .sbd-card {
      background: #fff;
      padding: 1.5rem;
      border-radius: 1rem;
      border: 1px solid #f3f4f6;
      box-shadow: 0 4px 20px rgba(0,0,0,0.04);
      transition: box-shadow 0.3s ease;
    }
    .sbd-card:hover { box-shadow: 0 8px 30px rgba(255,82,102,0.08); }

    .sbd-label {
      display: flex; align-items: center; gap: 0.5rem;
      font-size: 0.875rem; font-weight: 700; color: #1f2937;
      margin-bottom: 0.75rem; text-transform: uppercase; letter-spacing: 0.05em;
    }

    .sbd-textarea, .sbd-input {
      width: 100%;
      background: #f9fafb;
      border: 1px solid #e5e7eb;
      border-radius: 0.75rem;
      padding: 0.85rem 1rem;
      color: #374151;
      font-size: 0.875rem;
      transition: all 0.15s ease;
    }
    .sbd-textarea::placeholder, .sbd-input::placeholder { color: #9ca3af; }
    .sbd-textarea:focus, .sbd-input:focus {
      outline: none;
      border-color: #ff5266;
      box-shadow: 0 0 0 3px rgba(255,82,102,0.15);
      background: #f9fafb;
    }
    .sbd-textarea { resize: none; height: 7rem; }

    .sbd-live-preview {
      width: 100%;
      padding: 1.25rem;
      border-radius: 0.75rem;
      border: 1px solid;
      margin-top: 1rem;
      transition: all 0.2s ease;
    }

    .sbd-upload-zone {
      position: relative;
      cursor: pointer;
      width: 100%;
      height: 8rem;
      border-radius: 0.75rem;
      border: 2px dashed #e5e7eb;
      background: #f9fafb;
      display: flex; flex-direction: column; align-items: center; justify-content: center;
      overflow: hidden;
      transition: all 0.2s ease;
    }
    .sbd-upload-zone:hover { border-color: #ff5266; background: #fff8f8; }
    .sbd-upload-zone:hover .sbd-upload-overlay { opacity: 1; }
    .sbd-upload-overlay {
      position: absolute; inset: 0; display: flex; align-items: center; justify-content: center;
    }
    .sbd-upload-hint {
      background: rgba(255,255,255,0.9);
      backdrop-filter: blur(4px);
      padding: 0.5rem 1rem;
      border-radius: 999px;
      box-shadow: 0 1px 3px rgba(0,0,0,0.1);
      font-size: 0.75rem; font-weight: 600; color: #374151;
      opacity: 0; transition: opacity 0.2s ease;
    }

    .sbd-tpl-card {
      position: relative;
      display: flex; flex-direction: column;
      border-radius: 0.75rem;
      overflow: hidden;
      border: 2px solid #f3f4f6;
      height: 9rem;
      width: 100%;
      background: none;
      padding: 0;
      text-align: left;
      cursor: pointer;
      transition: all 0.2s ease;
    }
    .sbd-tpl-card:hover { border-color: #e5e7eb; box-shadow: 0 4px 12px rgba(0,0,0,0.08); }
    .sbd-tpl-card.selected {
      border-color: #ff5266;
      box-shadow: 0 0 0 4px rgba(255,82,102,0.15), 0 8px 20px rgba(0,0,0,0.1);
    }
    .sbd-tpl-preview { flex: 1; width: 100%; background: #f3f4f6; position: relative; }
    .sbd-tpl-check {
      position: absolute; inset: 0; background: rgba(255,82,102,0.1);
      display: flex; align-items: center; justify-content: center; z-index: 2;
    }
    .sbd-tpl-check-badge {
      background: #fff; border-radius: 50%; padding: 0.25rem; box-shadow: 0 1px 4px rgba(0,0,0,0.2);
    }
    .sbd-tpl-label {
      padding: 0.5rem; width: 100%; text-align: center;
      font-size: 0.75rem; font-weight: 600; color: #4b5563; background: #f9fafb;
      transition: all 0.2s ease;
    }
    .sbd-tpl-label.selected {
      background: linear-gradient(90deg, #ff5266, #ff9a3e); color: #fff;
    }

    .sbd-generate-btn {
      width: 100%;
      padding: 1rem;
      border-radius: 0.75rem;
      border: none;
      color: #fff;
      font-weight: 700;
      font-size: 1rem;
      display: flex; align-items: center; justify-content: center; gap: 0.5rem;
      cursor: pointer;
      background: linear-gradient(90deg, #ff5266, #ff9a3e);
      box-shadow: 0 8px 20px rgba(255,82,102,0.35);
      transition: all 0.2s ease;
    }
    .sbd-generate-btn:hover:not(:disabled) { box-shadow: 0 10px 25px rgba(255,82,102,0.45); transform: translateY(-2px); }
    .sbd-generate-btn:disabled {
      background: #d1d5db; box-shadow: none; cursor: not-allowed; transform: none;
    }

    .sbd-error-box {
      padding: 1rem; background: #fef2f2; color: #dc2626; font-size: 0.875rem;
      border-radius: 0.75rem; display: flex; align-items: flex-start; gap: 0.5rem;
      border: 1px solid #fee2e2;
    }

    .sbd-preview-panel {
      background: linear-gradient(135deg, #f9fafb, rgba(243,244,246,0.5));
      border-radius: 1.5rem; border: 1px solid #f3f4f6;
      padding: 1.5rem; min-height: 500px;
      display: flex; flex-direction: column; position: relative; overflow: hidden;
    }
    .sbd-preview-decoration {
      position: absolute; inset: 0; display: flex; align-items: center; justify-content: center;
      pointer-events: none; opacity: 0.5;
    }
    .sbd-download-btn {
      display: flex; align-items: center; gap: 0.5rem;
      padding: 0.5rem 1rem; background: #fff; border-radius: 999px;
      font-size: 0.875rem; font-weight: 600; color: #374151;
      box-shadow: 0 1px 3px rgba(0,0,0,0.08); border: 1px solid #e5e7eb;
      transition: all 0.2s ease; cursor: pointer;
    }
    .sbd-download-btn:hover { background: #f9fafb; box-shadow: 0 4px 10px rgba(0,0,0,0.1); }

    .sbd-idle-box {
      text-align: center; padding: 3rem;
      border: 2px dashed #e5e7eb; border-radius: 1rem;
      width: 100%; max-width: 28rem;
      background: rgba(255,255,255,0.6); backdrop-filter: blur(4px);
    }
    .sbd-idle-icon {
      width: 5rem; height: 5rem;
      background: linear-gradient(135deg, #f3f4f6, #e5e7eb);
      border-radius: 1rem; display: flex; align-items: center; justify-content: center;
      margin: 0 auto 1.25rem;
    }

    .sbd-gallery-thumb {
      aspect-ratio: 1 / 1; border-radius: 0.5rem; overflow: hidden;
      border: 2px solid #f3f4f6; padding: 0; background: none; cursor: pointer;
      transition: all 0.2s ease;
    }
    .sbd-gallery-thumb:hover { border-color: #ff5266; box-shadow: 0 6px 14px rgba(0,0,0,0.12); }
    .sbd-gallery-thumb img { width: 100%; height: 100%; object-fit: cover; transition: transform 0.3s ease; }
    .sbd-gallery-thumb:hover img { transform: scale(1.1); }

    .sbd-lightbox-overlay {
      position: fixed; inset: 0; background: rgba(0,0,0,0.8); backdrop-filter: blur(4px);
      z-index: 1050; display: flex; align-items: center; justify-content: center; padding: 1.5rem; cursor: pointer;
    }
    .sbd-lightbox-close {
      position: absolute; top: -1rem; right: -1rem; width: 2.5rem; height: 2.5rem;
      background: #fff; border-radius: 50%; box-shadow: 0 4px 10px rgba(0,0,0,0.2);
      display: flex; align-items: center; justify-content: center; color: #4b5563;
      border: none; cursor: pointer; z-index: 10; transition: all 0.2s ease;
    }
    .sbd-lightbox-close:hover { color: #ff5266; transform: scale(1.1); }

    .sbd-spin { animation: sbd-spin 1s linear infinite; }
    @keyframes sbd-spin { from { transform: rotate(0deg); } to { transform: rotate(360deg); } }

    .sbd-fade-in { animation: sbd-fade-in 0.3s ease; }
    @keyframes sbd-fade-in { from { opacity: 0; } to { opacity: 1; } }
  `}</style>
);

// ============================================
// SAMPLE IMAGES FOR GALLERY
// ============================================

const SAMPLE_IMAGES = [
  img01, img02, img03, img04,
  img05, img06, img07, img08,
  img09, img10, img11, img12,
  img13, img14, img15, img16
];



const TEMPLATES = [
  {
    id: 'design_1_grid_green',
    name: 'Grid Light (Green)',
    description: 'Engineering grid, clean white, emerald highlights.',
    textPreviewBg: '#ffffff',
    textPreviewBorder: '#e5e7eb',
    textPreviewMainColor: '#111827',
    textPreviewAccentColor: '#059669',
    promptModifier: "Design Style: White background with a subtle gray engineering grid pattern. Layout: Typography focused. Render the MAIN TEXT boldly in black. Highlight important words (from the input text only) in Emerald Green. Place user image as a clean cutout on the bottom right.",
    renderPreview: () => (
      <div style={{ width: '100%', height: '100%', background: '#fff', position: 'relative', overflow: 'hidden', border: '1px solid #f3f4f6' }}>
        <div style={{ position: 'absolute', inset: 0, opacity: 0.1, backgroundImage: 'linear-gradient(#000 1px, transparent 1px), linear-gradient(90deg, #000 1px, transparent 1px)', backgroundSize: '10px 10px' }}></div>
        <div style={{ position: 'absolute', top: 12, left: 12, right: 12 }}>
          <div style={{ height: 8, width: '75%', background: '#1f2937', borderRadius: 4, marginBottom: 4 }}></div>
          <div style={{ height: 8, width: '50%', background: '#22c55e', borderRadius: 4, marginBottom: 4 }}></div>
          <div style={{ height: 8, width: '66%', background: '#1f2937', borderRadius: 4 }}></div>
        </div>
        <div style={{ position: 'absolute', bottom: 0, right: 0, width: 48, height: 56, background: '#e5e7eb', borderTopLeftRadius: 16 }}></div>
        <div style={{ position: 'absolute', bottom: 8, left: '50%', transform: 'translateX(-50%)', width: 40, height: 12, background: '#f97316', borderRadius: 999 }}></div>
      </div>
    )
  },
  {
    id: 'design_2_dark_mode',
    name: 'Dark Grid Mode',
    description: 'High contrast black, neon lime accents.',
    textPreviewBg: '#111827',
    textPreviewBorder: '#374151',
    textPreviewMainColor: '#ffffff',
    textPreviewAccentColor: '#a3e635',
    promptModifier: "Design Style: Dark/Black background with subtle grid. Layout: Typography heavy. Render MAIN TEXT in large white bold fonts. Highlight key words (from input only) in Neon Lime. High contrast and motivational.",
    renderPreview: () => (
      <div style={{ width: '100%', height: '100%', background: '#111827', position: 'relative', overflow: 'hidden' }}>
        <div style={{ position: 'absolute', inset: 0, opacity: 0.1, backgroundImage: 'linear-gradient(#fff 1px, transparent 1px), linear-gradient(90deg, #fff 1px, transparent 1px)', backgroundSize: '10px 10px' }}></div>
        <div style={{ position: 'absolute', top: 12, left: 12, right: 12 }}>
          <div style={{ height: 8, width: '75%', background: '#fff', borderRadius: 4, marginBottom: 4 }}></div>
          <div style={{ height: 8, width: '50%', background: '#a3e635', borderRadius: 4, marginBottom: 4 }}></div>
          <div style={{ height: 8, width: '66%', background: '#fff', borderRadius: 4 }}></div>
        </div>
        <div style={{ position: 'absolute', bottom: 8, left: '50%', transform: 'translateX(-50%)', width: 40, height: 12, background: '#f97316', borderRadius: 999 }}></div>
      </div>
    )
  },
  {
    id: 'design_3_speech_bubble',
    name: 'Clean Speech',
    description: 'Teal background, white speech bubble focus.',
    textPreviewBg: '#0d9488',
    textPreviewBorder: '#14b8a6',
    textPreviewMainColor: '#ffffff',
    textPreviewAccentColor: '#99f6e4',
    promptModifier: "Design Style: Solid Teal background. Layout: Large white speech bubble at top containing the MAIN TEXT in black. User image centrally below/overlapping the bubble.",
    renderPreview: () => (
      <div style={{ width: '100%', height: '100%', background: '#0d9488', position: 'relative', overflow: 'hidden', display: 'flex', flexDirection: 'column', alignItems: 'center', paddingTop: 8 }}>
        <div style={{ width: '85%', height: 64, background: '#fff', borderRadius: 12, position: 'relative', marginBottom: 4, padding: 8 }}>
          <div style={{ height: 6, width: '100%', background: '#1f2937', borderRadius: 4, marginBottom: 4 }}></div>
          <div style={{ height: 6, width: '66%', background: '#1f2937', borderRadius: 4 }}></div>
          <div style={{ position: 'absolute', bottom: -4, left: '50%', transform: 'translateX(-50%) rotate(45deg)', width: 12, height: 12, background: '#fff' }}></div>
        </div>
        <div style={{ width: 40, height: 40, background: '#1f2937', borderRadius: '50%', marginTop: 4, border: '2px solid #0d9488', zIndex: 10 }}></div>
      </div>
    )
  },
  {
    id: 'design_4_grid_orange',
    name: 'Grid Light (Orange)',
    description: 'White grid, bright orange typography highlights.',
    textPreviewBg: '#ffffff',
    textPreviewBorder: '#e5e7eb',
    textPreviewMainColor: '#111827',
    textPreviewAccentColor: '#f97316',
    promptModifier: "Design Style: White background with engineering grid. Layout: Large bold black typography for MAIN TEXT. Highlight key words (from input only) in Bright Orange. User image as cutout on bottom right.",
    renderPreview: () => (
      <div style={{ width: '100%', height: '100%', background: '#fff', position: 'relative', overflow: 'hidden', border: '1px solid #f3f4f6' }}>
        <div style={{ position: 'absolute', inset: 0, opacity: 0.1, backgroundImage: 'linear-gradient(#000 1px, transparent 1px), linear-gradient(90deg, #000 1px, transparent 1px)', backgroundSize: '10px 10px' }}></div>
        <div style={{ position: 'absolute', top: 12, left: 12, right: 12 }}>
          <div style={{ height: 8, width: '75%', background: '#1f2937', borderRadius: 4, marginBottom: 4 }}></div>
          <div style={{ height: 8, width: '50%', background: '#f97316', borderRadius: 4, marginBottom: 4 }}></div>
          <div style={{ height: 8, width: '66%', background: '#1f2937', borderRadius: 4 }}></div>
        </div>
        <div style={{ position: 'absolute', bottom: 0, right: 0, width: 48, height: 56, background: '#e5e7eb', borderTopLeftRadius: 16 }}></div>
        <div style={{ position: 'absolute', bottom: 8, left: '50%', transform: 'translateX(-50%)', width: 40, height: 12, background: '#f97316', borderRadius: 999 }}></div>
      </div>
    )
  },
  {
    id: 'design_5_vibrant_pop_2',
    name: 'Vibrant Pop (Purple)',
    description: 'Electric Purple background, neon lime text.',
    textPreviewBg: '#9333ea',
    textPreviewBorder: '#c084fc',
    textPreviewMainColor: '#ffffff',
    textPreviewAccentColor: '#a3e635',
    promptModifier: "Design Style: Vibrant Pop Art (Version 2). Background: Solid Electric Purple. Layout: Large cutout of user on the left side. MAIN TEXT in massive bold Yellow or Lime fonts on the right. High energy, YouTube thumbnail style. Make the person look energetic.",
    renderPreview: () => (
      <div style={{ width: '100%', height: '100%', background: '#9333ea', position: 'relative', overflow: 'hidden' }}>
        <div style={{ position: 'absolute', top: 0, right: 0, width: 96, height: 96, background: '#a3e635', borderBottomLeftRadius: 999, opacity: 0.8 }}></div>
        <div style={{ position: 'absolute', bottom: 16, left: 16, width: '100%' }}>
          <div style={{ height: 12, width: '50%', background: '#fff', transform: 'skewX(-10deg)', marginBottom: 4 }}></div>
          <div style={{ height: 12, width: '66%', background: '#a3e635', transform: 'skewX(-10deg)' }}></div>
        </div>
        <div style={{ position: 'absolute', bottom: 0, left: 0, width: '33%', height: '66%', background: '#6b21a8', borderTopRightRadius: 24, opacity: 0.5 }}></div>
      </div>
    )
  },
  {
    id: 'design_6_full_overlay',
    name: 'Full Image Focus',
    description: 'Full background image with text overlay.',
    textPreviewBg: '#111827',
    textPreviewBorder: '#374151',
    textPreviewMainColor: '#ffffff',
    textPreviewAccentColor: '#fb923c',
    promptModifier: "Design Style: Full-bleed immersive layout. User's photo as DOMINANT background (80%+). Dark gradient overlay for text readability. MAIN TEXT in white, readable.",
    renderPreview: () => (
      <div style={{ width: '100%', height: '100%', background: '#d1d5db', position: 'relative', overflow: 'hidden' }}>
        <div style={{ position: 'absolute', inset: 0, background: '#9ca3af', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#6b7280' }}>
          <HiPhoto style={{ fontSize: '2.25rem', opacity: 0.2 }} />
        </div>
        <div style={{ position: 'absolute', inset: 0, background: 'linear-gradient(to top, rgba(0,0,0,0.8), transparent 60%)' }}></div>
        <div style={{ position: 'absolute', bottom: 16, left: 12, right: 12 }}>
          <div style={{ height: 8, width: '75%', background: '#fff', borderRadius: 4, marginBottom: 4 }}></div>
          <div style={{ height: 8, width: '50%', background: '#fb923c', borderRadius: 4, marginBottom: 4 }}></div>
          <div style={{ height: 8, width: '66%', background: '#fff', borderRadius: 4 }}></div>
        </div>
      </div>
    )
  },
  {
    id: 'design_7_modern_split',
    name: 'Modern Split (Large)',
    description: 'Half image, half text. Very clean.',
    textPreviewBg: '#ffffff',
    textPreviewBorder: '#e5e7eb',
    textPreviewMainColor: '#0f172a',
    textPreviewAccentColor: '#2563eb',
    promptModifier: "Design Style: 50/50 Split. Right side: Full height user photo (50% width). Left side: Clean solid background for MAIN TEXT. Modern Sans-Serif.",
    renderPreview: () => (
      <div style={{ width: '100%', height: '100%', background: '#fff', position: 'relative', overflow: 'hidden', display: 'flex' }}>
        <div style={{ width: '50%', padding: 8, display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
          <div style={{ height: 8, width: '100%', background: '#1e293b', borderRadius: 4, marginBottom: 4 }}></div>
          <div style={{ height: 8, width: '75%', background: '#2563eb', borderRadius: 4, marginBottom: 4 }}></div>
          <div style={{ height: 8, width: '100%', background: '#1e293b', borderRadius: 4 }}></div>
        </div>
        <div style={{ width: '50%', background: '#d1d5db', height: '100%', position: 'relative' }}>
          <div style={{ position: 'absolute', inset: 0, background: '#9ca3af', opacity: 0.5 }}></div>
          <div style={{ position: 'absolute', bottom: 0, right: 0, width: '100%', height: '80%', background: '#6b7280', borderTopLeftRadius: 12 }}></div>
        </div>
      </div>
    )
  },
  {
    id: 'design_8_vibrant_pop_3',
    name: 'Vibrant Pop (Red)',
    description: 'Cyber Red background, cyan accents.',
    textPreviewBg: '#ef4444',
    textPreviewBorder: '#f87171',
    textPreviewMainColor: '#ffffff',
    textPreviewAccentColor: '#67e8f9',
    promptModifier: "Design Style: Vibrant Pop Art (Version 3). Background: Cyber Red (#ff0040) or Hot Pink. Layout: User cutout in center or right with 'glitch' art style elements. MAIN TEXT huge, white with Cyan drop shadows. Very modern, edgy and viral.",
    renderPreview: () => (
      <div style={{ width: '100%', height: '100%', background: '#ef4444', position: 'relative', overflow: 'hidden', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <div style={{ position: 'absolute', inset: 0, background: 'radial-gradient(circle, #f87171, #dc2626)' }}></div>
        <div style={{ position: 'relative', zIndex: 10, width: '75%', textAlign: 'center' }}>
          <div style={{ height: 12, width: '100%', background: '#22d3ee', transform: 'rotate(-2deg)', marginBottom: 4, boxShadow: '0 1px 3px rgba(0,0,0,0.15)' }}></div>
          <div style={{ height: 12, width: '75%', background: '#fff', transform: 'rotate(1deg)', margin: '0 auto', boxShadow: '0 1px 3px rgba(0,0,0,0.15)' }}></div>
        </div>
      </div>
    )
  },
  {
    id: 'design_9_vibrant_pop',
    name: 'Vibrant Pop (Yellow)',
    description: 'Large cutout person on bold yellow background.',
    textPreviewBg: '#facc15',
    textPreviewBorder: '#eab308',
    textPreviewMainColor: '#000000',
    textPreviewAccentColor: '#ffffff',
    promptModifier: "Design Style: Vibrant Pop Art. Solid bright background (Yellow/Blue). LARGE user cutout on side. MAIN TEXT is massive, bold, punchy.",
    renderPreview: () => (
      <div style={{ width: '100%', height: '100%', background: '#facc15', position: 'relative', overflow: 'hidden' }}>
        <div style={{ position: 'absolute', top: 16, left: 8, width: '66%', zIndex: 10 }}>
          <div style={{ height: 12, width: '100%', background: '#000', transform: 'skewX(-10deg)', marginBottom: 4 }}></div>
          <div style={{ height: 12, width: '75%', background: '#fff', transform: 'skewX(-10deg)', marginBottom: 4 }}></div>
          <div style={{ height: 12, width: '100%', background: '#000', transform: 'skewX(-10deg)' }}></div>
        </div>
        <div style={{ position: 'absolute', bottom: 0, right: 0, width: '55%', height: '85%', background: '#1f2937', borderTopLeftRadius: 24 }}></div>
      </div>
    )
  },
  {
    id: 'design_10_glassmorphism',
    name: 'Dark Glass (Cosmic)',
    description: 'Dark blurred background, premium black glass.',
    textPreviewBg: 'rgba(0,0,0,0.6)',
    textPreviewBorder: '#4b5563',
    textPreviewMainColor: '#ffffff',
    textPreviewAccentColor: '#f472b6',
    promptModifier: "Design Style: Dark Glassmorphism. Background: Deep rich dark gradient (Dark Blue/Purple/Black). Glass Card: Dark translucent black frosted glass (not white) containing MAIN TEXT in white. User photo blended or popping out behind the glass. Premium, sleek.",
    renderPreview: () => (
      <div style={{ width: '100%', height: '100%', background: '#111827', position: 'relative', overflow: 'hidden' }}>
        <div style={{ position: 'absolute', inset: 0, background: 'linear-gradient(to bottom right, #1f2937, #000)' }}></div>
        <div style={{ position: 'absolute', top: -20, left: -20, width: 96, height: 96, background: '#db2777', borderRadius: '50%', filter: 'blur(24px)', opacity: 0.6 }}></div>
        <div style={{ position: 'absolute', bottom: -20, right: -20, width: 128, height: 128, background: '#2563eb', borderRadius: '50%', filter: 'blur(24px)', opacity: 0.6 }}></div>
        <div style={{ position: 'absolute', inset: 0, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <div style={{ width: '85%', height: '40%', background: 'rgba(0,0,0,0.3)', backdropFilter: 'blur(6px)', borderRadius: 12, border: '1px solid rgba(255,255,255,0.1)', boxShadow: '0 8px 20px rgba(0,0,0,0.3)', padding: 12, position: 'relative', marginTop: 64 }}>
            <div style={{ height: 8, width: '100%', background: '#e5e7eb', borderRadius: 4, marginBottom: 4, opacity: 0.8 }}></div>
            <div style={{ height: 8, width: '66%', background: '#ec4899', borderRadius: 4 }}></div>
          </div>
          <div style={{ position: 'absolute', bottom: '35%', width: 64, height: 64, background: '#374151', borderRadius: '50%', border: '2px solid rgba(255,255,255,0.2)' }}></div>
        </div>
      </div>
    )
  },
  {
    id: 'design_11_glass_ocean',
    name: 'Dark Glass (Ocean)',
    description: 'Deep teal/ocean gradient, cyan accents.',
    textPreviewBg: 'rgba(8,51,68,0.8)',
    textPreviewBorder: '#0e7490',
    textPreviewMainColor: '#ffffff',
    textPreviewAccentColor: '#22d3ee',
    promptModifier: "Design Style: Dark Glassmorphism. Background: Deep Teal and Ocean Blue Gradient. Glass Card: Dark translucent glass. Text: White with glowing Cyan accents. Mood: Futuristic, calm, tech.",
    renderPreview: () => (
      <div style={{ width: '100%', height: '100%', background: '#083344', position: 'relative', overflow: 'hidden' }}>
        <div style={{ position: 'absolute', inset: 0, background: 'linear-gradient(to top, #000, #164e63)' }}></div>
        <div style={{ position: 'absolute', top: 0, right: 0, width: 128, height: 128, background: '#06b6d4', borderRadius: '50%', filter: 'blur(40px)', opacity: 0.4 }}></div>
        <div style={{ position: 'absolute', inset: 0, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <div style={{ width: '85%', height: '40%', background: 'rgba(0,0,0,0.4)', backdropFilter: 'blur(6px)', borderRadius: 12, border: '1px solid rgba(6,182,212,0.3)', boxShadow: '0 6px 15px rgba(0,0,0,0.25)', padding: 12, position: 'relative', marginTop: 64 }}>
            <div style={{ height: 8, width: '100%', background: '#fff', borderRadius: 4, marginBottom: 4, opacity: 0.9 }}></div>
            <div style={{ height: 8, width: '50%', background: '#22d3ee', borderRadius: 4 }}></div>
          </div>
        </div>
      </div>
    )
  },
  {
    id: 'design_12_glass_sunset',
    name: 'Dark Glass (Sunset)',
    description: 'Deep purple to orange gradient, warm glow.',
    textPreviewBg: 'rgba(30,27,75,0.8)',
    textPreviewBorder: 'rgba(249,115,22,0.5)',
    textPreviewMainColor: '#ffffff',
    textPreviewAccentColor: '#fb923c',
    promptModifier: "Design Style: Dark Glassmorphism. Background: Sunset Gradient (Deep Purple to Fiery Orange). Glass Card: Dark translucent glass. Text: White with warm Orange/Gold accents. Mood: Warm, energetic, premium.",
    renderPreview: () => (
      <div style={{ width: '100%', height: '100%', background: '#1e1b4b', position: 'relative', overflow: 'hidden' }}>
        <div style={{ position: 'absolute', inset: 0, background: 'linear-gradient(to bottom right, #312e81, #581c87, #9a3412)' }}></div>
        <div style={{ position: 'absolute', bottom: -10, left: 0, width: 160, height: 160, background: '#f97316', borderRadius: '50%', filter: 'blur(40px)', opacity: 0.5 }}></div>
        <div style={{ position: 'absolute', inset: 0, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <div style={{ width: '85%', height: '40%', background: 'rgba(0,0,0,0.4)', backdropFilter: 'blur(6px)', borderRadius: 12, border: '1px solid rgba(249,115,22,0.3)', boxShadow: '0 6px 15px rgba(0,0,0,0.25)', padding: 12, position: 'relative', marginTop: 64 }}>
            <div style={{ height: 8, width: '100%', background: '#fff', borderRadius: 4, marginBottom: 4, opacity: 0.9 }}></div>
            <div style={{ height: 8, width: '66%', background: '#fb923c', borderRadius: 4 }}></div>
          </div>
        </div>
      </div>
    )
  },
  {
    id: 'design_13_glass_emerald',
    name: 'Dark Glass (Emerald)',
    description: 'Black to green gradient, neon green accents.',
    textPreviewBg: 'rgba(0,0,0,0.8)',
    textPreviewBorder: '#059669',
    textPreviewMainColor: '#ffffff',
    textPreviewAccentColor: '#34d399',
    promptModifier: "Design Style: Dark Glassmorphism. Background: Deep Black to Emerald Green gradient. Glass Card: Dark translucent glass. Text: White with Neon Green accents. Mood: Wealth, growth, matrix-style.",
    renderPreview: () => (
      <div style={{ width: '100%', height: '100%', background: '#000', position: 'relative', overflow: 'hidden' }}>
        <div style={{ position: 'absolute', inset: 0, background: 'linear-gradient(to bottom, #000, #022c22)' }}></div>
        <div style={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', width: 192, height: 192, background: '#059669', borderRadius: '50%', filter: 'blur(60px)', opacity: 0.3 }}></div>
        <div style={{ position: 'absolute', inset: 0, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <div style={{ width: '85%', height: '40%', background: 'rgba(0,0,0,0.5)', backdropFilter: 'blur(6px)', borderRadius: 12, border: '1px solid rgba(16,185,129,0.4)', boxShadow: '0 6px 15px rgba(0,0,0,0.25)', padding: 12, position: 'relative', marginTop: 64 }}>
            <div style={{ height: 8, width: '75%', background: '#fff', borderRadius: 4, marginBottom: 4, opacity: 0.9 }}></div>
            <div style={{ height: 8, width: '100%', background: '#34d399', borderRadius: 4 }}></div>
          </div>
        </div>
      </div>
    )
  },
  {
    id: 'design_14_glass_gold',
    name: 'Dark Glass (Gold)',
    description: 'Luxury black & gold gradient.',
    textPreviewBg: 'rgba(0,0,0,0.9)',
    textPreviewBorder: '#ca8a04',
    textPreviewMainColor: '#ffffff',
    textPreviewAccentColor: '#facc15',
    promptModifier: "Design Style: Dark Glassmorphism. Background: Luxury Black with Gold dust/lights. Glass Card: Dark translucent glass with Gold border. Text: White with Metallic Gold accents. Mood: Luxury, VIP, exclusive.",
    renderPreview: () => (
      <div style={{ width: '100%', height: '100%', background: '#000', position: 'relative', overflow: 'hidden' }}>
        <div style={{ position: 'absolute', inset: 0, background: 'radial-gradient(ellipse at top, rgba(120,53,15,0.4), #000, #000)' }}></div>
        <div style={{ position: 'absolute', inset: 0, opacity: 0.2, backgroundImage: 'radial-gradient(#fbbf24 1px, transparent 1px)', backgroundSize: '20px 20px' }}></div>
        <div style={{ position: 'absolute', inset: 0, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <div style={{ width: '85%', height: '40%', background: 'rgba(0,0,0,0.6)', backdropFilter: 'blur(6px)', borderRadius: 12, border: '1px solid rgba(234,179,8,0.5)', boxShadow: '0 6px 15px rgba(0,0,0,0.25)', padding: 12, position: 'relative', marginTop: 64 }}>
            <div style={{ height: 8, width: '100%', background: '#f3f4f6', borderRadius: 4, marginBottom: 4, opacity: 0.9 }}></div>
            <div style={{ height: 8, width: '50%', background: '#facc15', borderRadius: 4 }}></div>
          </div>
        </div>
      </div>
    )
  }
];

// ============================================
// HELPER FUNCTIONS
// ============================================

const fileToBase64 = (file) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      const result = reader.result;
      const base64 = result.split(',')[1];
      resolve(base64);
    };
    reader.onerror = error => reject(error);
  });
};

const fileToDataUrl = (file) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = reject;
  });
};

// ============================================
// MAIN COMPONENT
// ============================================

export default function SocialBannerDesignPro() {
  // ❌ auth সরিয়ে দেওয়া হয়েছে: const { withAuthGuard } = useAuthGuard();

  // Form States - DEFAULT VALUES SET
  const [context, setContext] = useState('');
  const [userName, setUserName] = useState('Habibur Rahman');
  const [userTitle, setUserTitle] = useState('Founder HR LIMON');
  const [ctaText, setCtaText] = useState('বিস্তারিত নিচে');

  // Image & Template States
  const [selectedImage, setSelectedImage] = useState(null);
  const [selectedImagePreview, setSelectedImagePreview] = useState(null);
  const [selectedTemplateId, setSelectedTemplateId] = useState(TEMPLATES[0].id);

  // Generation States
  const [generatedImageUrl, setGeneratedImageUrl] = useState(null);
  const [loading, setLoading] = useState(false);
  const [downloading, setDownloading] = useState(false);
  const [error, setError] = useState(null);

  // Lightbox State
  const [lightboxImage, setLightboxImage] = useState(null);

  const fileInputRef = useRef(null);

  // Get selected template
  const selectedTemplate = TEMPLATES.find(t => t.id === selectedTemplateId) || TEMPLATES[0];

  // Split text into 3 lines for preview
  const getPreviewLines = (text) => {
    if (!text) return ['Your text will', 'appear here with', 'live preview'];

    if (text.includes('\n')) {
      const lines = text.split('\n');
      return [lines[0] || '', lines[1] || '', lines[2] || lines.slice(2).join(' ')];
    }

    const words = text.trim().split(/\s+/);
    if (words.length <= 3) return [text, '', ''];

    const chunk = Math.ceil(words.length / 3);
    return [
      words.slice(0, chunk).join(' '),
      words.slice(chunk, chunk * 2).join(' '),
      words.slice(chunk * 2).join(' ')
    ];
  };

  const previewLines = getPreviewLines(context);

  // Handle File Selection
  const handleFileChange = async (e) => {
    if (e.target.files && e.target.files[0]) {
      const file = e.target.files[0];
      setSelectedImage(file);
      try {
        const preview = await fileToDataUrl(file);
        setSelectedImagePreview(preview);
      } catch (err) {
        console.error("Error previewing image", err);
      }
    }
  };

  // ✅ auth wrapper ছাড়া সরাসরি handleGenerate
  const handleGenerate = async () => {
    if (!context) {
      setError("Please enter the main text for your post.");
      return;
    }
    if (!selectedImage) {
      setError("Please upload your photo.");
      return;
    }

    setLoading(true);
    setError(null);
    setGeneratedImageUrl(null);

    try {
      const template = TEMPLATES.find(t => t.id === selectedTemplateId) || TEMPLATES[0];
      const base64Image = await fileToBase64(selectedImage);

      const prompt = `
        You are a smart graphic design engine.
        Task: Create a social media image (1:1) using the text provided and the user's photo.

        --- 1. INTELLIGENT EXPRESSION & POSE ADAPTATION ---
        Analyze the sentiment and topic of the "MAIN TEXT" below. 
        Modify the person's pose and facial expression in the generated image to MATCH that sentiment, while keeping their identity from the uploaded photo.
        
        Logic Examples:
        - IF text is "Tips/Advice/How-to" -> The person should be POINTING at the text or holding their hand up as if explaining. Expression: Helpful, Smart.
        - IF text is "Shocking/Secret/Viral" -> The person should look SURPRISED (wide eyes, open mouth, hands on cheeks). Expression: Shocked.
        - IF text is "Success/Money/Win" -> The person should look CONFIDENT, smiling, or showing a Thumbs Up. Expression: Happy, Winner.
        - IF text is "Serious/Warning" -> The person should look SERIOUS and authoritative. Arms crossed or intense stare.
        
        *CRITICAL*: You MUST change the pose/expression to match the text, but the person MUST still look like the user in the reference image.

        --- 2. STRICT CONTENT RULES (NO NEW TEXT) ---
        1. MAIN TEXT: "${context}"
           - RENDER EXACTLY AS WRITTEN.
           - DO NOT ADD ANY WORDS.
           - DO NOT REPEAT WORDS.
           - CHECK SPELLING AGAINST INPUT.
        2. NAME: "${userName || ' '}"
        3. TITLE: "${userTitle || ' '}"
        4. BUTTON: "${ctaText}"

        --- 3. DESIGN STYLE ---
        ${template.promptModifier}
        
        --- FINAL CHECKS ---
        - Ensure the pose interacts with the text layout if possible (e.g. pointing at it).
        - Verify text accuracy.
      `;

      const res = await fetch('https://img.hrlimon.com/api/generate-banner', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          prompt: prompt,
          imageBase64: base64Image,
          imageType: selectedImage.type
        }),
      });

      const data = await res.json();

      if (data.url) {
        setGeneratedImageUrl(data.url);
      } else {
        throw new Error(data.error || "No image was generated. Please try again.");
      }

    } catch (err) {
      console.error(err);
      setError(err.message || "Failed to generate image. Please try again.");
    } finally {
      setLoading(false);
    }
  };

const downloadImage = async () => {
  if (!generatedImageUrl) return;

  setDownloading(true);
  try {
    // data: URL হলে সরাসরি download
    if (generatedImageUrl.startsWith('data:')) {
      const link = document.createElement('a');
      link.href = generatedImageUrl;
      link.download = `banner-${Date.now()}.png`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      return;
    }

    // Backend proxy (port 8001)
    const proxyBase = 'https://img.hrlimon.com'; // production-এ আপনার API domain
    const response = await fetch(
      `${proxyBase}/api/proxy-image?url=${encodeURIComponent(generatedImageUrl)}`
    );
    if (!response.ok) throw new Error('Download failed');

    const blob = await response.blob();
    const url = window.URL.createObjectURL(blob);

    const link = document.createElement('a');
    link.href = url;
    link.download = `banner-${Date.now()}.png`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  } catch (err) {
    console.error('Download Error:', err);
    // Fallback: new tab-এ খুলে দিন
    window.open(generatedImageUrl, '_blank');
  } finally {
    setDownloading(false);
  }
};

  // ============================================
  // RENDER UI
  // ============================================

  return (
    <div className="sbd-root">
      <BrandStyles />

      {/* Background Glow Effects */}
      <div className="sbd-glow sbd-glow-1"></div>
      <div className="sbd-glow sbd-glow-2"></div>
      <div className="sbd-glow sbd-glow-3"></div>

      {/* Main Content */}
      <main className="bg-white position-relative rounded-4" style={{ zIndex: 1 }}>
        <div className="row g-4">

          {/* ==================== LEFT PANEL: INPUTS ==================== */}
          <div className="col-12 col-lg-5 d-flex flex-column gap-4">

            {/* Card 1: Main Text Input */}
            <div className="sbd-card">
              <label className="sbd-label">
                <HiPencil style={{ color: '#ff5266', fontSize: '1.125rem' }} />
                Post Content
              </label>

              <textarea
                value={context}
                onChange={(e) => setContext(e.target.value)}
                placeholder="Write your main caption or message here..."
                className="sbd-textarea"
              />

              {/* Live Typography Preview */}
              <div
                className="sbd-live-preview"
                style={{ background: selectedTemplate.textPreviewBg, borderColor: selectedTemplate.textPreviewBorder }}
              >
                <div className="d-flex align-items-center justify-content-between mb-3">
                  <span style={{ fontSize: '0.625rem', textTransform: 'uppercase', fontWeight: 700, letterSpacing: '0.1em', opacity: 0.5, color: selectedTemplate.textPreviewMainColor }}>
                    Live Preview
                  </span>
                  <HiEye style={{ fontSize: '0.875rem', opacity: 0.5, color: selectedTemplate.textPreviewMainColor }} />
                </div>
                <div className="d-flex flex-column gap-1">
                  <div style={{ fontSize: '1.125rem', fontWeight: 700, lineHeight: 1.2, color: selectedTemplate.textPreviewMainColor }}>
                    {previewLines[0] || <span style={{ opacity: 0.3 }}>Line 1...</span>}
                  </div>
                  <div style={{ fontSize: '1.25rem', fontWeight: 900, lineHeight: 1.2, color: selectedTemplate.textPreviewAccentColor }}>
                    {previewLines[1] || <span style={{ opacity: 0.3 }}>Line 2...</span>}
                  </div>
                  <div style={{ fontSize: '1.125rem', fontWeight: 700, lineHeight: 1.2, color: selectedTemplate.textPreviewMainColor }}>
                    {previewLines[2] || <span style={{ opacity: 0.3 }}>Line 3...</span>}
                  </div>
                </div>
              </div>
            </div>

            {/* Card 2: Profile Info */}
            <div className="sbd-card">
              <label className="sbd-label">
                <HiUser style={{ color: '#ff9a3e', fontSize: '1.125rem' }} />
                Profile Details
              </label>

              <div className="d-flex flex-column gap-3">
                <div>
                  <span className="d-block mb-1" style={{ fontSize: '0.75rem', fontWeight: 500, color: '#9ca3af' }}>Your Name</span>
                  <input
                    type="text"
                    value={userName}
                    onChange={(e) => setUserName(e.target.value)}
                    placeholder="e.g. John Smith"
                    className="sbd-input"
                  />
                </div>
                <div>
                  <span className="d-block mb-1" style={{ fontSize: '0.75rem', fontWeight: 500, color: '#9ca3af' }}>Your Title / Role</span>
                  <input
                    type="text"
                    value={userTitle}
                    onChange={(e) => setUserTitle(e.target.value)}
                    placeholder="e.g. CEO & Founder"
                    className="sbd-input"
                  />
                </div>
                <div>
                  <span className="d-flex align-items-center gap-1 mb-1" style={{ fontSize: '0.75rem', fontWeight: 500, color: '#9ca3af' }}>
                    <HiCursorArrowRays style={{ fontSize: '0.75rem' }} /> CTA Button Text
                  </span>
                  <input
                    type="text"
                    value={ctaText}
                    onChange={(e) => setCtaText(e.target.value)}
                    placeholder="e.g. Learn More"
                    className="sbd-input"
                  />
                </div>
              </div>
            </div>

            {/* Card 3: Image Upload */}
            <div className="sbd-card">
              <label className="sbd-label">
                <HiPhoto style={{ color: '#ff5266', fontSize: '1.125rem' }} />
                Your Photo
              </label>

              <div onClick={() => fileInputRef.current?.click()} className="sbd-upload-zone">
                <input
                  type="file"
                  ref={fileInputRef}
                  onChange={handleFileChange}
                  style={{ display: 'none' }}
                  accept="image/*"
                />

                {selectedImagePreview ? (
                  <>
                    <img src={selectedImagePreview} alt="Preview" style={{ width: '100%', height: '100%', objectFit: 'cover', opacity: 0.8 }} />
                    <div className="sbd-upload-overlay">
                      <div className="sbd-upload-hint">Click to Change</div>
                    </div>
                  </>
                ) : (
                  <div className="d-flex flex-column align-items-center">
                    <HiCloudArrowUp style={{ color: '#ff5266', fontSize: '1.75rem', marginBottom: 8 }} />
                    <span style={{ fontSize: '0.875rem', color: '#6b7280', fontWeight: 500 }}>Click to upload photo</span>
                    <span style={{ fontSize: '0.75rem', color: '#9ca3af', marginTop: 4 }}>PNG, JPG up to 10MB</span>
                  </div>
                )}
              </div>
            </div>

            {/* Card 4: Design Templates */}
            <div className="sbd-card">
              <label className="sbd-label">
                <HiSwatch style={{ color: '#ff9a3e', fontSize: '1.125rem' }} />
                Select Design Style
              </label>

              <div className="row g-3" style={{ maxHeight: 400, overflowY: 'auto', paddingRight: 4 }}>
                {TEMPLATES.map((t) => (
                  <div className="col-6" key={t.id}>
                    <button
                      onClick={() => setSelectedTemplateId(t.id)}
                      className={`sbd-tpl-card ${selectedTemplateId === t.id ? 'selected' : ''}`}
                    >
                      <div className="sbd-tpl-preview">
                        {t.renderPreview()}
                        {selectedTemplateId === t.id && (
                          <div className="sbd-tpl-check">
                            <div className="sbd-tpl-check-badge">
                              <HiCheckCircle style={{ color: '#ff5266', fontSize: '1.25rem' }} />
                            </div>
                          </div>
                        )}
                      </div>
                      <div className={`sbd-tpl-label ${selectedTemplateId === t.id ? 'selected' : ''}`}>
                        {t.name}
                      </div>
                    </button>
                  </div>
                ))}
              </div>
            </div>

            {/* Generate Button */}
            <button onClick={handleGenerate} disabled={loading} className="sbd-generate-btn">
              {loading ? (
                <>
                  <svg className="sbd-spin" width="20" height="20" viewBox="0 0 24 24" fill="none">
                    <circle style={{ opacity: 0.25 }} cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                    <path style={{ opacity: 0.75 }} fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                  </svg>
                  <span>Generating...</span>
                </>
              ) : (
                <>
                  <HiSparkles style={{ fontSize: '1.25rem' }} />
                  <span>Generate Banner</span>
                </>
              )}
            </button>

            {/* Error Message */}
            {error && (
              <div className="sbd-error-box">
                <HiXMark style={{ marginTop: 2, flexShrink: 0, fontSize: '1.125rem' }} />
                <span>{error}</span>
              </div>
            )}
          </div>

          {/* ==================== RIGHT PANEL: PREVIEW ==================== */}
          <div className="col-12 col-lg-7 d-flex flex-column gap-4">

            {/* Preview Result */}
            <div className="sbd-preview-panel">

              {/* Decorative Background */}
              <div className="sbd-preview-decoration">
                <div style={{ width: 500, height: 500, background: 'linear-gradient(to top right, #fff, #f3f4f6)', borderRadius: '50%' }}></div>
              </div>

              {/* Header */}
              <div className="d-flex justify-content-between align-items-center mb-4" style={{ position: 'relative', zIndex: 1 }}>
                <div className="d-flex align-items-center gap-2">
                  <HiSquares2X2 style={{ color: '#ff5266', fontSize: '1.25rem' }} />
                  <h2 className="mb-0" style={{ fontSize: '1.125rem', fontWeight: 700, color: '#1f2937' }}>Preview Result</h2>
                </div>
                {generatedImageUrl && (
                  <button onClick={downloadImage} disabled={downloading} className="sbd-download-btn">
                    {downloading ? (
                      <div className="sbd-spin" style={{ height: 16, width: 16, border: '2px solid #ff5266', borderTopColor: 'transparent', borderRadius: '50%' }}></div>
                    ) : (
                      <HiArrowDownTray style={{ color: '#ff5266' }} />
                    )}
                    <span>{downloading ? 'Processing...' : 'Download'}</span>
                  </button>
                )}
              </div>

              {/* Preview Area */}
              <div className="flex-grow-1 d-flex align-items-center justify-content-center" style={{ position: 'relative', zIndex: 1 }}>
                {/* 1. LOADING STATE */}
                {loading ? (
                  <div className="d-flex flex-column align-items-center justify-content-center text-center p-4">
                    <div style={{ position: 'relative', width: 80, height: 80, marginBottom: 16 }}>
                      <div style={{ position: 'absolute', inset: 0, border: '4px solid #e5e7eb', borderRadius: '50%' }}></div>
                      <div className="sbd-spin" style={{ position: 'absolute', inset: 0, border: '4px solid #ff5266', borderTopColor: 'transparent', borderRadius: '50%' }}></div>
                      <HiSparkles style={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', color: '#ff5266', fontSize: '1.5rem' }} />
                    </div>
                    <h3 style={{ fontSize: '1.125rem', fontWeight: 700, color: '#1f2937' }}>Creating your masterpiece...</h3>
                    <p style={{ fontSize: '0.875rem', color: '#6b7280', marginTop: 8 }}>Analyzing context, adapting pose, and rendering typography.</p>
                  </div>
                ) :

                /* 2. SUCCESS STATE (IMAGE GENERATED) */
                generatedImageUrl ? (
                  <div className="sbd-fade-in d-flex align-items-center justify-content-center" style={{ position: 'relative', width: '100%', height: '100%' }}>
                    <img
                      src={generatedImageUrl}
                      alt="Generated Post"
                      style={{ maxHeight: '100%', maxWidth: '100%', objectFit: 'contain', borderRadius: 16, boxShadow: '0 20px 40px rgba(0,0,0,0.25)', border: '4px solid #fff' }}
                    />
                  </div>
                ) :

                /* 3. IDLE STATE (PLACEHOLDER) */
                (
                  <div className="sbd-idle-box">
                    <div className="sbd-idle-icon">
                      <HiPhoto style={{ fontSize: '1.75rem', color: '#9ca3af' }} />
                    </div>
                    <h3 style={{ fontSize: '1.125rem', fontWeight: 700, color: '#9ca3af', marginBottom: 8 }}>No Image Generated Yet</h3>
                    <p style={{ color: '#9ca3af', fontSize: '0.875rem', lineHeight: 1.6 }}>
                      Fill in the details, upload your photo, and click Generate to create your post.
                    </p>
                  </div>
                )}
              </div>
            </div>

            {/* ==================== SAMPLE GALLERY ==================== */}
            <div className="sbd-card">
              <div className="d-flex align-items-center gap-2 mb-3">
                <HiViewColumns style={{ color: '#ff9a3e', fontSize: '1.125rem' }} />
                <h3 className="mb-0" style={{ fontSize: '0.875rem', fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.05em', color: '#1f2937' }}>Sample Designs</h3>
                <span className="ms-auto" style={{ fontSize: '0.75rem', color: '#9ca3af' }}>Click to preview</span>
              </div>

              <div className="row g-2">
               {SAMPLE_IMAGES.map((img, index) => (
  <div className="col-3" key={index}>
    <button onClick={() => setLightboxImage(img)} className="sbd-gallery-thumb">
      <img
        src={img}                    // ← was img.src
        alt={`Sample ${index + 1}`}
        onError={(e) => { e.target.style.display = 'none'; }}
      />
    </button>
  </div>
))}
              </div>
            </div>
          </div>
        </div>
      </main>

      {/* Footer */}
      <footer className="w-100 text-center py-5" style={{ position: 'relative', zIndex: 1 }}></footer>

      {/* ==================== LIGHTBOX MODAL ==================== */}
      {lightboxImage && (
        <div className="sbd-lightbox-overlay" onClick={() => setLightboxImage(null)}>
          <div style={{ position: 'relative', maxWidth: '48rem', maxHeight: '90vh' }}>
            {/* Close Button */}
            <button onClick={() => setLightboxImage(null)} className="sbd-lightbox-close">
              <HiXMark style={{ fontSize: '1.5rem' }} />
            </button>

            {/* Image */}
         <img
  src={lightboxImage}              // ← was lightboxImage?.src
  alt="Sample Preview"
  style={{ maxWidth: '100%', maxHeight: '85vh', objectFit: 'contain', borderRadius: 16, boxShadow: '0 20px 40px rgba(0,0,0,0.3)' }}
  onClick={(e) => e.stopPropagation()}
/>
          </div>
        </div>
      )}
    </div>
  );
}